var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check-circle-mono",
    clipPath: "url(#clip0_96_32770)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0376 5.95867L6.78083 9.216C6.67111 9.32497 6.52276 9.38612 6.36812 9.38612C6.21349 9.38612 6.06513 9.32497 5.95541 9.216L3.96275 7.22334C3.90859 7.16918 3.86563 7.10488 3.83631 7.03412C3.807 6.96335 3.79192 6.88751 3.79192 6.81092C3.79192 6.65623 3.85337 6.50788 3.96275 6.3985C4.07213 6.28912 4.22048 6.22767 4.37516 6.22767C4.52985 6.22767 4.6782 6.28912 4.78758 6.3985L6.36783 7.97875L9.21275 5.13384C9.26691 5.07968 9.3312 5.03671 9.40197 5.0074C9.47273 4.97809 9.54857 4.96301 9.62516 4.96301C9.70176 4.96301 9.7776 4.97809 9.84836 5.0074C9.91912 5.03671 9.98342 5.07968 10.0376 5.13384C10.0917 5.18799 10.1347 5.25229 10.164 5.32305C10.1933 5.39382 10.2084 5.46966 10.2084 5.54625C10.2084 5.62285 10.1933 5.69869 10.164 5.76945C10.1347 5.84021 10.0917 5.90451 10.0376 5.95867ZM7.00016 0.583252C3.45641 0.583252 0.583496 3.45617 0.583496 6.99992C0.583496 10.5437 3.45641 13.4166 7.00016 13.4166C10.5439 13.4166 13.4168 10.5437 13.4168 6.99992C13.4168 3.45617 10.5439 0.583252 7.00016 0.583252Z",
    fill: "#70737C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_32770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGray);
export default __webpack_public_path__ + "static/media/icon_check_gray.51f32cbc6f18b1f6aa6ba99f03ded136.svg";
export { ForwardRef as ReactComponent };